import { PlusInSquareIcon, TemplatePositionIcon } from "assets/icons";
import { useBoolean } from "hooks";
import { t } from "i18next";
import { useState } from "react";
import { Button, Pagination, SearchInput } from "ui";

import {
  DeleteFeedInsertModal,
  FeedInsertModal,
  FeedInsertsSettingsModal,
  FeedInsertsTable
} from "../../components";
import { FeedInsertsListItem } from "../../content.types";
import { useFeedInsertsList } from "../../hooks";

import styles from "./Feed.module.scss";

const Feed = () => {
  const {
    feedInserts,
    searchValue,
    setSearchValue,
    sorting,
    setSorting,
    page,
    totalItems,
    setPage,
    isLoading,
    setFeedInserts
  } = useFeedInsertsList();

  const {
    value: isFeedInsertModalOpen,
    setTrue: openFeedInsertModal,
    setFalse: closeFeedInsertModal
  } = useBoolean(false);

  const {
    value: isFeedInsertsSettingsModalOpen,
    setTrue: openFeedInsertsSettingsModal,
    setFalse: closeFeedInsertsSettingsModal
  } = useBoolean(false);

  const [editableFeedInsert, setEditableFeedInsert] =
    useState<FeedInsertsListItem | null>(null);

  const [deleteFeedInsertId, setDeleteFeedInsertId] = useState<string | null>(
    null
  );

  return (
    <div className={styles.feed}>
      <div className={styles.feed_header}>
        <SearchInput value={searchValue} onChange={setSearchValue} />

        <div className={styles.feed_header_buttons}>
          <Button
            icon={<TemplatePositionIcon />}
            onClick={openFeedInsertsSettingsModal}
            variant="additional"
          >
            {t("Position Settings")}
          </Button>

          <Button icon={<PlusInSquareIcon />} onClick={openFeedInsertModal}>
            {t("Add Feed Insert")}
          </Button>
        </div>
      </div>

      <div className={styles.feed_table}>
        <FeedInsertsTable
          feedInserts={feedInserts ?? []}
          sorting={sorting}
          setSorting={setSorting}
          isLoading={isLoading}
          onDelete={setDeleteFeedInsertId}
          onEdit={(feedInsert) => {
            setEditableFeedInsert(feedInsert);
            openFeedInsertModal();
          }}
          setFeedInserts={setFeedInserts}
          isDragDisabled={!!searchValue || sorting.length > 0}
        />
      </div>

      <Pagination
        currentPage={page}
        onChange={setPage}
        totalItems={totalItems}
      />

      <FeedInsertModal
        isOpen={isFeedInsertModalOpen}
        editableInsert={editableFeedInsert}
        onClose={() => {
          closeFeedInsertModal();
          setEditableFeedInsert(null);
        }}
      />

      <DeleteFeedInsertModal
        isOpen={!!deleteFeedInsertId}
        id={String(deleteFeedInsertId)}
        onClose={() => {
          setDeleteFeedInsertId(null);
        }}
      />

      {isFeedInsertsSettingsModalOpen && (
        <FeedInsertsSettingsModal
          isOpen={isFeedInsertsSettingsModalOpen}
          onClose={closeFeedInsertsSettingsModal}
        />
      )}
    </div>
  );
};

export default Feed;
